import { useFormContext } from "react-hook-form";
import { Input } from "@mui/material";

const Index = () => {
  const { register } = useFormContext();
  return (
    <Input
      type={"hidden"}
      {...register("operaterPlatforme.primarniIdentifikator.tip")}
      value={""}
    />
  );
};

export default Index;
